export const createCategoriesSlice = (set) => ({
  inventoryCategories: [
    { label: 'Flavor', value: 'Flavor' },
    { label: 'Packaging', value: 'Packaging' },
    { label: 'Toppings', value: 'Toppings' },
    { label: 'Syrup', value: 'Syrup' },
    { label: 'Other', value: 'Other' }
  ],
  productCategories: [
    { label: 'Cones', value: 'Cones' },
    { label: 'Cups', value: 'Cups' },
    { label: 'Family Packs', value: 'Family Packs' },
    { label: 'Drinks', value: 'Drinks' },
    { label: 'Sundaes', value: 'Sundaes' }
  ],

  setInventoryCategories: (categories) => set({ inventoryCategories: categories }),
  setProductCategories: (categories) => set({ productCategories: categories }),

  addInventoryCategory: (category) => set((state) => ({
    inventoryCategories: [...state.inventoryCategories, { label: category, value: category }]
  })),

  removeInventoryCategory: (value) => set((state) => ({
    inventoryCategories: state.inventoryCategories.filter((cat) => cat.value !== value)
  })),

  addProductCategory: (category) => set((state) => ({
    productCategories: [...state.productCategories, { label: category, value: category }]
  })),

  removeProductCategory: (value) => set((state) => ({
    productCategories: state.productCategories.filter((cat) => cat.value !== value)
  }))
});
